import Base from "./base";

class EmailTestResource extends Base {
  path = "/v2/admin/email-test";

  getTypes = () => this.getRequest(`${this.path}/types`);

  send = (data) => this.postRequest(`${this.path}/send`, data);
}

export default new EmailTestResource();
